module.exports = __webpack_public_path__ + "static/media/paintCanExplore.cb6537eb.png";